export default "__VITE_ASSET__DJqhRxYk__"